import React from "react";
import JSONLD from "web/react/components/json-ld/json-ld";
export function PaywallMarkup(_ref) {
  var cssSelector = _ref.cssSelector;
  var jsonLDData = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    isAccessibleForFree: "False",
    hasPart: {
      "@type": "WebPageElement",
      isAccessibleForFree: "False",
      cssSelector: ".".concat(cssSelector)
    }
  };
  return React.createElement(JSONLD, {
    JSONLD: jsonLDData
  });
}
export default PaywallMarkup;